import { openModal } from '../../src/js/components/modals';
/*
|--------------------------------------------------------------------------
| A function that scrolls to a particular slide before opening the team modal
|--------------------------------------------------------------------------
*/
const openTeamModal = (modalId, slideId) => {
  const targetModal = document.getElementById(modalId);

  if( !targetModal ) {
    return;
  }

  const modalTrack = targetModal.querySelector(`.splide__list`);
  const splideInstance = targetModal.splideInstance;

  const slides = splideInstance.Components.Elements?.slides;

  if( !slides ) {
    return;
  }

  // Find the assocaited slide using the data-slide-id attribute
  const targetSlideIndex = slides.findIndex((slide) => { 
    return slide.dataset.slideId == slideId;
  });

  if( targetSlideIndex !== -1 ) {
    // Disable transitions
    modalTrack.style.transition = "none !important";

    // Scroll to the specified slide
    splideInstance.Components.Controller.go(targetSlideIndex);

    // Re-enable transitions
    modalTrack.style.transition = "";
  }

  // Open the modal
  openModal(modalId);
}

export { openTeamModal }